import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../../../me'
import type { Api } from '../api'
import * as dataTransformers from '../data-transformers'
import type { Feature } from '../feature'

export const onSubmitPromptRequest = store.effects.create(
  (feature: Feature, api: Api, meFeature: me.Feature) =>
    feature.actions.submitPrompt.request.observe().pipe(
      rxjs.withLatestFrom(
        meFeature.contexts.selectors.zoneContext.asObservable,
        dataTransformers.csv$(feature.selectors.file.asObservable),
      ),
      rxjs.switchMap(([action, context, fileData]) => {
        const request = action.data
        if (!context) {
          // Without a context, we can't do anything
          return rxjs.of(
            feature.actions.submitPrompt.error.from(action).create({
              error: new Error('Cannot determine current context'),
              request,
            }),
          )
        }
        // We call the API and return its result (or throw its error)
        return api.generate(context, { fileData, prompt: request.prompt }).pipe(
          rxjs.map(response =>
            feature.actions.submitPrompt.success
              .from(action)
              .create({ request, response }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.submitPrompt.error
                .from(action)
                .create({ error, request }),
            ),
          ),
        )
      }),
    ),
)
